import React, { useEffect, useState, useRef, createRef } from 'react';
import { View, Text, Pressable, ScrollView, Image, StyleSheet, Dimensions, TouchableOpacity, Icon2 } from '../lib/react-native-compat';
import pptxgen from "pptxgenjs";
import moment from 'moment';
import { useAtom } from 'jotai';
import html2canvas from 'html2canvas';

// Implementation for captureRef using html2canvas
const captureRef = async (ref, options) => {
    // Handle both ref objects and direct DOM elements
    const element = ref?.current || ref;
    
    if (!element || !element.nodeType) {
        console.warn('captureRef: Invalid ref provided', ref);
        return '';
    }
    try {
        const canvas = await html2canvas(element, {
            backgroundColor: '#ffffff',
            scale: 2, // Higher quality
            logging: false,
            useCORS: true,
            allowTaint: true
        });
        return canvas.toDataURL('image/png');
    } catch (error) {
        console.error('captureRef error:', error);
        return '';
    }
};
import forecastTop from '../assets/forecast.png';
import coLogTop from '../assets/coLog.png';
import productivityTop from '../assets/productivity.png';
import summaryTop from '../assets/summary.png';
import photosTop from '../assets/photos.png';
import laborClassificationTop from '../assets/laborClassification.png';
import laborGraphsTop from '../assets/laborGraphs.png';
import thirdPartyTop from '../assets/ThirdPartySpend.png';
import revenueCurveTop from '../assets/RevenueCurve.png';
import footer from '../assets/footer.png';
//import RNFS from 'react-native-fs';
//import * as FileSystem from 'expo-file-system';
import Forecast from './bidForecast';
import COLogPSRView from './cologPSRView';
import ProductivityCombined from './productivityCombined';
import ProductivityTracker from './productivityTracker-old';
import LaborClassification from './laborClassification';
import Summary from './summary';
import { selectedTeamAtom, selectedVersionAtom, dataSourceVersionAtom, actualHoursAtom, isLiveVersionAtom, psrSlideSelectionsAtom, dataSourceJobsAtom, selectedJobAtom, selectedJobDataAtom, budgetHoursGraphTestAtom, eacHoursGraphTestAtom, actualHoursGraphTestAtom, eacHoursAtom, budgetHoursTestAtom, eacHoursTestAtom, actualHoursTestAtom, budgetHoursAtom, updatedBudgetHoursAtom, updatedBudgetHoursTestAtom, jobUserDataAtom, projectCompleteAtom } from '../store/company';
import LaborGraphs from './laborGraphs';
import ThirdPartyCostDrivers from './thirdPartyCostDrivers';
import CostCurveForecast from './costCurveForecast';
import { pNum, fNum } from '../db/company';


const s = StyleSheet.create({
    cell: {
        height: 20,
        borderBottomWidth: 1,
        borderColor: '#aeadaf',
        padding: 2,
        textWrap: 'nowrap',
        overflow: 'hidden',
        textAlign: 'right'
    },
    cellt: {
        borderBottomWidth: 1,
        borderColor: '#aeadaf',
        padding: 2,
        paddingBottom: 3,
        textAlign: 'right',
        fontSize: 12
    },
    celll: {
        height: 20,
        borderBottomWidth: 1,
        borderColor: '#aeadaf',
        padding: 2,
        textWrap: 'nowrap',
        overflow: 'hidden',
        textAlign: 'left',
        fontSize: 12
    },
    container: {
        flex: 1,
        backgroundColor: '#fff',
        paddingLeft: 20
    },
    tabItem: {
        paddingVertical: 12,
        paddingHorizontal: 16,
        borderBottomWidth: 2,
        borderBottomColor: 'transparent',
    },
    activeTab: {
        borderBottomColor: '#192440',
    },
    tabText: {
        fontSize: 16,
        color: '#888',
    },
    activeText: {
        color: '#000',
        fontWeight: '600',
    },
    content: {
        padding: 20,
    },
    contentText: {
        fontSize: 16,
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    }
});

const PSRSlideJob = () => {
    const [versionInfo, setVersionInfo] = useState({})
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [jobs, setJobs] = useAtom(dataSourceJobsAtom);
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [job, setSelectedJobData] = useAtom(selectedJobDataAtom);
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [projectComplete, setProjectComplete] = useAtom(projectCompleteAtom);
    const [startDateActual, setStartDateActual] = useState();
    const [completionDateForecast, setCompletionDateForecast] = useState();

    // Add CSS animation for spinner
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);
    const [forecast, setForecast] = useState(true)
    const [coLog, setCoLog] = useState(true)
    const [productivity, setProductivity] = useState(true)
    const [laborGraphs, setLaborGraphs] = useState(true)
    const [laborRatios, setLaborRatios] = useState(true)
    const [thirdParty, setThirdParty] = useState(true)
    const [revenueCurve, setRevenueCurve] = useState(true)
    const [photos, setPhotos] = useState(true)
    const [hideProgram, setHideProgram] = useState(false)
    const slides = useRef({})
    const jobsRefs = useRef({})
    const [waiting, setWaiting] = useState(false);
    const imageSummaryRef = useRef();
    const imageForecastRef = useRef();
    const imageCoLogRef = useRef();
    const imageProductivityRef = useRef();
    const imageLaborGraphsRef = useRef();
    const imageLaborRatiosRef = useRef();
    const imageThirdPartyRef = useRef();
    const imageRevenueCurveRef = useRef();
    const imageFooterRef = useRef();
    const imagePhotoRef = useRef();
    const jobInfoRef = useRef();
    const summaryInfoRef = useRef();
    const actualHoursRef = useRef();
    const budgetHoursRef = useRef();
    const updatedBudgetHoursRef = useRef();
    const eacHoursRef = useRef();
    const actualHoursTestRef = useRef();
    const budgetHoursTestRef = useRef();
    const updatedBudgetHoursTestRef = useRef();
    const eacHoursTestRef = useRef();
    const [waitingSummary, setWaitingSummary] = useState(false);
    const [activeTab, setActiveTab] = useState('Labor S Curve');
    const tabs = ['Job', 'Team'];
    const [pageWidth, setPageWidth] = useState(Dimensions.get('window').width);
    const [loadAgain, setLoadAgain] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(100);

    useEffect(() => {
        const handleResize = () => {
            setPageWidth(Dimensions.get('window').width);
        };

        const subscription = Dimensions.addEventListener('change', handleResize);

        return () => {
            subscription?.remove();
        };
    }, []);

    useEffect(() => {
        const updateZoom = () => {
            const zoom = Math.round(window.devicePixelRatio * 100);
            setZoomLevel(zoom);
        };

        updateZoom();
        window.addEventListener('resize', updateZoom);

        return () => {
            window.removeEventListener('resize', updateZoom);
        };
    }, []);

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions, selectedVersion]);

    useEffect(() => {
        if (jobUserData && jobUserData.length > 0) {
            jobUserData.forEach((data) => {
                if (data.Forecast_Field_Name === 'startDateActual') {
                    setStartDateActual(data.Forecast_Value);
                }
                if (data.Forecast_Field_Name === 'completionDateForecast') {
                    setCompletionDateForecast(data.Forecast_Value);
                    setProjectComplete(data.Forecast_Value);
                }
            });
        }
    }, [jobUserData]);

    useEffect(() => {
        //const filtered = jobs ? jobs.filter(j => j.Cat_Code_BU_27 == selectedTeam).filter(a => a.Cat_Code_BU_08_Description != 'Time & Materials').map(j => j.BU_ID) : []
        setFilteredJobs([selectedJob])
    }, [selectedJob])//jobs

    const getImageSize = async (imageUri) => {
        return new Promise((resolve, reject) => {
            const img = new window.Image();
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = (error) => {
                reject(error);
            };
            img.src = imageUri;
        });
    };

    useEffect(() => {
        console.log('loadAgain', loadAgain)
        if (!loadAgain) setLoadAgain(true)
    }, [loadAgain])

    const setActualHoursRef = (ref) => {
        actualHoursRef.current = ref;
    };

    const setBudgetHoursRef = (ref) => {
        budgetHoursRef.current = ref;
    };

    const setUpdatedBudgetHoursRef = (ref) => {
        updatedBudgetHoursRef.current = ref;
    };

    const setEacHoursref = (ref) => {
        eacHoursRef.current = ref;
    };

    const setActualHoursTestRef = (ref) => {
        actualHoursTestRef.current = ref;
    };

    const setBudgetHoursTestRef = (ref) => {
        budgetHoursTestRef.current = ref;
    };

    const setUpdatedBudgetHoursTestRef = (ref) => {
        updatedBudgetHoursTestRef.current = ref;
    };

    const setEacHoursTestRef = (ref) => {
        eacHoursTestRef.current = ref;
    };

    const setJobRef = (jobId, type, ref) => {
        //console.log('ref jobId', jobId, type, ref)
        const jobRefCopy = jobsRefs.current
        if (jobRefCopy[jobId]) {
            jobRefCopy[jobId][type] = ref;
        } else {
            jobRefCopy[jobId] = { [type]: ref };
        }
        jobsRefs.current = jobRefCopy;
    };

    const addImageSlide = async (pres, title, imageUri, actualWidth, actualHeight, head, foot, info = null) => {
        console.log('here in add images', pres)
        const maxSlideWidthInPixels = 1456; // 11 inches at 96 PPI
        const maxSlideHeightInPixels = 1000; // Approximate height for landscape orientation

        const maxSlideWidthInPixelsSummary = 1600
        const maxSlideHeightInPixelsSummary = 770
        
        // For productivity slide, use a smaller max height to prevent clipping
        const maxSlideHeightInPixelsProductivity = 750; // Reduced height for productivity to fit within slide bounds

        // Calculate scaling factor to fit within slide dimensions
        const scaleFactor = Math.min(maxSlideWidthInPixels / actualWidth, maxSlideHeightInPixels / actualHeight);
        const scaleFactorSummary = Math.min(maxSlideWidthInPixelsSummary / actualWidth, maxSlideHeightInPixelsSummary / actualHeight);
        const scaleFactorProductivity = Math.min(maxSlideWidthInPixels / actualWidth, maxSlideHeightInPixelsProductivity / actualHeight);
        console.log('scaleFactor', scaleFactor, actualWidth, actualHeight, maxSlideWidthInPixels, maxSlideHeightInPixels)
        const scaledWidth = actualWidth * scaleFactor * 0.00617; // 0.00617 is approx 1 pixel in PowerPoint unit
        const scaledHeight = actualHeight * scaleFactor * 0.00617;

        const scaledWidthSummary = actualWidth * scaleFactorSummary * 0.00617;
        const scaledHeightSummary = actualHeight * scaleFactorSummary * 0.00617;
        
        const scaledWidthProductivity = actualWidth * scaleFactorProductivity * 0.00617;
        const scaledHeightProductivity = actualHeight * scaleFactorProductivity * 0.00617;

        const slide = pres.addSlide();
        //console.log('head', head.length, foot.length, info.length, imageUri)
        slide.addImage({ data: head, x: 0, y: 0, w: 6, h: 0.57 });
        slide.addImage({ data: foot, x: 0, y: 5.4, w: 10, h: 0.23 });
        
        if (info && info.length > 0) {
            slide.addImage({ data: info, x: 6.09, y: 0.08, w: 3.15, h: 0.4 });
        }

        if (title.includes('Labor Graphs')) {
            const totalSlideWidth = 10; // 10 inches (960px at 96 DPI)
            const availableHeight = 4.8; // from 0.6 to 5.4
            const centeredX = (totalSlideWidth - scaledWidthSummary) / 2; // Center the content horizontally
            const centeredY = 0.6 + (availableHeight - scaledHeightSummary) / 2;
            console.log('centeredX', centeredX, scaledWidthSummary)
            slide.addImage({ data: imageUri, x: centeredX, y: centeredY, w: scaledWidthSummary, h: scaledHeightSummary });
        } else if (title.includes('Ratios')) {
            slide.addImage({ data: imageUri, x: 3.21, y: 1.61, w: 3.57, h: 2.41 });
        } else if (title.includes('Forecast')) {
            slide.addImage({ data: imageUri, x: 0.5, y: 0.6, w: scaledWidth, h: scaledHeight });
        } else if (title.includes('Summary')) {
            slide.addImage({ data: imageUri, x: 0.5, y: 0.75, w: scaledWidth, h: scaledHeight });
        } else if (title.includes('Photos')) {

        } else if (title.includes('CO Log')) {
            // Center vertically: available space is from 0.65 (after header+jobinfo) to 5.4 (footer) = 4.75 inches
            const availableHeight = 4.75;
            const centeredY = 0.65 + (availableHeight - scaledHeight) / 2;
            slide.addImage({ data: imageUri, x: 0.5, y: centeredY, w: scaledWidth, h: scaledHeight });
        } else if (title.includes('Cost Drivers')) {
            // Scale the (tall) cost-drivers card to fit the content area and center it.
            const totalSlideWidth = 10;
            const availableHeight = 4.75; // from 0.65 (after header/jobinfo) to 5.4 (footer)
            const fit = Math.min(1, availableHeight / scaledHeight, 9 / scaledWidth);
            const w = scaledWidth * fit;
            const h = scaledHeight * fit;
            const centeredX = (totalSlideWidth - w) / 2;
            const centeredY = 0.65 + (availableHeight - h) / 2;
            slide.addImage({ data: imageUri, x: centeredX, y: centeredY, w, h });
        } else if (title.includes('Revenue Curve')) {
            // Scale the stacked line+bar chart pair to fit the content area and center it.
            const totalSlideWidth = 10;
            const availableHeight = 4.75; // from 0.65 (after header/jobinfo) to 5.4 (footer)
            const fit = Math.min(1, availableHeight / scaledHeight, 9 / scaledWidth);
            const w = scaledWidth * fit;
            const h = scaledHeight * fit;
            const centeredX = (totalSlideWidth - w) / 2;
            const centeredY = 0.65 + (availableHeight - h) / 2;
            slide.addImage({ data: imageUri, x: centeredX, y: centeredY, w, h });
        } else if (title.includes('Productivity')) {
            // Center the productivity image horizontally and vertically
            const totalSlideWidth = 10;
            const availableHeight = 4.7; // from 0.7 to 5.4
            const centeredX = (totalSlideWidth - scaledWidthProductivity) / 2;
            const centeredY = 0.7 + (availableHeight - scaledHeightProductivity) / 2;
            slide.addImage({ data: imageUri, x: centeredX, y: centeredY, w: scaledWidthProductivity, h: scaledHeightProductivity });
        } else {
            slide.addImage({ data: imageUri, x: 0.5, y: 1, w: scaledWidth, h: scaledHeight });
        }
    };

    // New function to add a slide with two CO Log images combined
    const addCombinedImageSlide = async (pres, title, imageUri1, actualWidth1, actualHeight1, imageUri2, actualWidth2, actualHeight2, head, foot, info = null) => {
        console.log('Adding combined CO Log slide', imageUri1.length, imageUri2.length, actualWidth1, actualHeight1, actualWidth2, actualHeight2);

        const maxSlideWidthInInches = 9; // Maximum width available for content (10 - 1 for margins)

        // Scale images only if they exceed max width
        let width1 = actualWidth1;
        let height1 = actualHeight1;
        let width2 = actualWidth2;
        let height2 = actualHeight2;

        // Check and scale first image if it's too wide
        if (width1 > maxSlideWidthInInches) {
            const scaleFactor1 = maxSlideWidthInInches / width1;
            width1 = maxSlideWidthInInches;
            height1 = height1 * scaleFactor1;
            console.log(`Scaling first image by factor: ${scaleFactor1}`);
        }

        // Check and scale second image if it's too wide
        if (width2 > maxSlideWidthInInches) {
            const scaleFactor2 = maxSlideWidthInInches / width2;
            width2 = maxSlideWidthInInches;
            height2 = height2 * scaleFactor2;
            console.log(`Scaling second image by factor: ${scaleFactor2}`);
        }

        const slide = pres.addSlide();
        slide.addImage({ data: head, x: 0, y: 0, w: 6, h: 0.57 });
        slide.addImage({ data: foot, x: 0, y: 5.4, w: 10, h: 0.23 });
        
        if (info && info.length > 0) {
            slide.addImage({ data: info, x: 6.09, y: 0.08, w: 3.15, h: 0.4 });
        }

        // Position first image at the top
        slide.addImage({ data: imageUri1, x: 0.5, y: 0.65, w: width1, h: height1 });

        // Position second image below the first with small gap
        const secondImageY = 0.65 + height1 + 0.1; // 0.1 inch gap
        slide.addImage({ data: imageUri2, x: 0.5, y: secondImageY, w: width2, h: height2 });
        console.log('done')
    };

    const addMultiSectionSlide = async (pres, title, sections, head, foot, info = null) => {
        console.log(`Adding multi-section CO Log slide with ${sections.length} sections`);

        const maxSlideWidthInInches = 9;
        const gapBetweenSections = 0.1;

        const slide = pres.addSlide();
        slide.addImage({ data: head, x: 0, y: 0, w: 6, h: 0.57 });
        slide.addImage({ data: foot, x: 0, y: 5.4, w: 10, h: 0.23 });
        
        if (info && info.length > 0) {
            slide.addImage({ data: info, x: 6.09, y: 0.08, w: 3.15, h: 0.4 });
        }

        let currentY = 0.65;
        sections.forEach((section, index) => {
            let width = section.width;
            let height = section.height;

            // Scale if too wide
            if (width > maxSlideWidthInInches) {
                const scaleFactor = maxSlideWidthInInches / width;
                width = maxSlideWidthInInches;
                height = height * scaleFactor;
            }

            // Add section image
            slide.addImage({ data: section.shot, x: 0.5, y: currentY, w: width, h: height });
            
            // Update Y position for next section
            currentY += height + (index < sections.length - 1 ? gapBetweenSections : 0);
        });

        console.log('Multi-section slide complete');
    };

    const generatePptxReportSummary = async () => {
        setWaitingSummary(true);
        try {
            const pres = new pptxgen();
            const footerShot = await captureRef(imageFooterRef, { format: 'png', quality: 1 });
            const headerShot = await captureRef(imageSummaryRef, { format: 'png', quality: 1 });
            const summaryInfoShot = await captureRef(summaryInfoRef, { format: 'png', quality: 1 });
            console.log('here beg')
            if (jobsRefs.current[selectedJob]?.summary.length) {
                const listSummaryRefs = jobsRefs.current[selectedJob]?.summary
                console.log('listSummaryRefs', listSummaryRefs)
                for (let i = 0; i < listSummaryRefs.length; i++) {
                    console.log('slide i', i)
                    const summaryShot = await captureRef(listSummaryRefs[i], { format: 'png', quality: 1 });
                    console.log('here ', i)
                    const { width, height } = await getImageSize(summaryShot);
                    console.log('here 2', i, height, width, pres)
                    await addImageSlide(pres, `Job ${selectedJob}: Summary`, summaryShot, width * 0.00617, height * 0.00617, headerShot, footerShot, summaryInfoShot);
                }
            }
            await pres.writeFile({ fileName: 'CostForecastReport.pptx' });
            setWaitingSummary(false);
        } catch (error) {
            console.error("Error capturing screenshots", error);
            setWaitingSummary(false);
        }
    };

    const generatePptxReport = async () => {
        setWaiting(true);
        try {
            const pres = new pptxgen();

            const footerShot = await captureRef(imageFooterRef, { format: 'png', quality: 1 });
            const jobInfoShot = await captureRef(jobInfoRef, { format: 'png', quality: 1 });
            console.log('jobsRefs.current', selectedJob, jobsRefs.current);
            
            if (forecast && jobsRefs.current[selectedJob]?.forecast) {
                console.log('Generating Forecast slide');
                const headerShot = await captureRef(imageForecastRef, { format: 'png', quality: 1 });
                const forecastShot = await captureRef(jobsRefs.current[selectedJob]?.forecast, { format: 'png', quality: 1 });
                const { width, height } = await getImageSize(forecastShot);
                addImageSlide(pres, `Job ${selectedJob}: Forecast`, forecastShot, width * 0.00617, height * 0.00617, headerShot, footerShot, jobInfoShot);
            }

            console.log('past first')

            if (coLog && jobsRefs.current[selectedJob]?.coLog) {
                console.log('Generating CO Log slides');
                const headerShot = await captureRef(imageCoLogRef, { format: 'png', quality: 1 });
                if (jobsRefs.current[selectedJob]?.coLog.length) {
                    const listCoRefs = jobsRefs.current[selectedJob]?.coLog
                    let i = 0;

                    while (i < listCoRefs.length) {
                        const availableHeight = 4.75;
                        const maxSlideWidthInInches = 9;
                        const gapBetweenSections = 0.1;
                        
                        // Capture and measure sections starting from current index
                        const sectionsToFit = [];
                        let totalHeight = 0;
                        
                        for (let j = i; j < listCoRefs.length; j++) {
                            const sectionShot = await captureRef(listCoRefs[j], { format: 'png', quality: 1 });
                            const { width, height } = await getImageSize(sectionShot);
                            
                            let finalHeight = height * 0.00617;
                            const widthInInches = width * 0.00617;
                            
                            // Account for width scaling
                            if (widthInInches > maxSlideWidthInInches) {
                                const scaleFactor = maxSlideWidthInInches / widthInInches;
                                finalHeight = finalHeight * scaleFactor;
                            }
                            
                            // Add gap if not the first section
                            const heightWithGap = finalHeight + (sectionsToFit.length > 0 ? gapBetweenSections : 0);
                            
                            // Check if adding this section would exceed available height
                            if (totalHeight + heightWithGap <= availableHeight) {
                                sectionsToFit.push({
                                    shot: sectionShot,
                                    width: width * 0.00617,
                                    height: height * 0.00617
                                });
                                totalHeight += heightWithGap;
                            } else {
                                // Can't fit more sections
                                break;
                            }
                        }
                        
                        // Generate slide based on how many sections fit
                        if (sectionsToFit.length === 0) {
                            console.error('No sections could fit on slide - this should not happen');
                            i += 1;
                        } else if (sectionsToFit.length === 1) {
                            console.log(`Adding single CO Log section ${i}`);
                            addImageSlide(pres, `Job ${selectedJob}: CO Log`, 
                                sectionsToFit[0].shot, sectionsToFit[0].width, sectionsToFit[0].height, 
                                headerShot, footerShot, jobInfoShot);
                            i += 1;
                        } else if (sectionsToFit.length === 2) {
                            console.log(`Combining 2 CO Log sections ${i}-${i+1} (total height: ${totalHeight.toFixed(2)})`);
                            addCombinedImageSlide(pres, `Job ${selectedJob}: CO Log`,
                                sectionsToFit[0].shot, sectionsToFit[0].width, sectionsToFit[0].height,
                                sectionsToFit[1].shot, sectionsToFit[1].width, sectionsToFit[1].height,
                                headerShot, footerShot, jobInfoShot);
                            i += 2;
                        } else {
                            console.log(`Combining ${sectionsToFit.length} CO Log sections ${i}-${i+sectionsToFit.length-1} (total height: ${totalHeight.toFixed(2)})`);
                            addMultiSectionSlide(pres, `Job ${selectedJob}: CO Log`, sectionsToFit, headerShot, footerShot, jobInfoShot);
                            i += sectionsToFit.length;
                        }
                    }
                }

                //const coLogShot = await captureRef(jobsRefs.current[selectedJob]?.coLog[0], { format: 'png', quality: 1 });
                //await capturePaginatedScreenshots(refs.coLog, `Job ${selectedJob}: CO Logs`, pres, 0.00617);
            }

            if (productivity && jobsRefs.current[selectedJob]?.productivity) {
                console.log('Generating Productivity slide');
                const headerShot = await captureRef(imageProductivityRef, { format: 'png', quality: 1 });
                const productivityShot = await captureRef(jobsRefs.current[selectedJob]?.productivity, { format: 'png', quality: 1 });
                const { width, height } = await getImageSize(productivityShot);
                addImageSlide(pres, `Job ${selectedJob}: Productivity Tracker`, productivityShot, width * 0.00617, height * 0.00617, headerShot, footerShot, jobInfoShot);
            }

            if (laborGraphs && jobsRefs.current[selectedJob]?.laborGraphs) {
                console.log('Generating Labor Graphs slide');
                const headerShot = await captureRef(imageLaborGraphsRef, { format: 'png', quality: 1 });
                const laborGraphsShot = await captureRef(jobsRefs.current[selectedJob]?.laborGraphs, { format: 'png', quality: 1 });
                const { width, height } = await getImageSize(laborGraphsShot);
                addImageSlide(pres, `Job ${selectedJob}: Labor Graphs`, laborGraphsShot, width * 0.00617, height * 0.00617, headerShot, footerShot, jobInfoShot);
            }

            // if (slideTypes.laborGraphs) {
            //     const laborShot = await captureRef(laborRef, { format: 'png', quality: 1 });
            //     const { width, height } = await getImageSize(laborShot);
            //     addImageSlide(pres, `Job ${selectedJob}: Labor Graphs`, laborShot, width * 0.00617, height * 0.00617);
            // }

            if (laborRatios && jobsRefs.current[selectedJob]?.laborRatios) {
                console.log('Generating Labor Ratios slide');
                const headerShot = await captureRef(imageLaborRatiosRef, { format: 'png', quality: 1 });
                const laborRatiosShot = await captureRef(jobsRefs.current[selectedJob]?.laborRatios, { format: 'png', quality: 1 });
                const { width, height } = await getImageSize(laborRatiosShot);
                addImageSlide(pres, `Job ${selectedJob}: Labor Ratios`, laborRatiosShot, width * 0.00617, height * 0.00617, headerShot, footerShot, jobInfoShot);
            }

            if (thirdParty && jobsRefs.current[selectedJob]?.thirdParty) {
                console.log('Generating 3rd-Party Cost Drivers slide');
                const headerShot = await captureRef(imageThirdPartyRef, { format: 'png', quality: 1 });
                const thirdPartyShot = await captureRef(jobsRefs.current[selectedJob]?.thirdParty, { format: 'png', quality: 1 });
                const { width, height } = await getImageSize(thirdPartyShot);
                addImageSlide(pres, `Job ${selectedJob}: Cost Drivers`, thirdPartyShot, width * 0.00617, height * 0.00617, headerShot, footerShot, jobInfoShot);
            }

            if (revenueCurve && jobsRefs.current[selectedJob]?.revenueCurve) {
                console.log('Generating Revenue Curve slide');
                const headerShot = await captureRef(imageRevenueCurveRef, { format: 'png', quality: 1 });
                const chartsShot = await captureRef(jobsRefs.current[selectedJob]?.revenueCurve, { format: 'png', quality: 1 });
                const { width, height } = await getImageSize(chartsShot);
                addImageSlide(pres, `Job ${selectedJob}: Revenue Curve`, chartsShot, width * 0.00617, height * 0.00617, headerShot, footerShot, jobInfoShot);
            }

            if (photos) {
                console.log('Generating Photos slide');
                const headerShot = await captureRef(imagePhotoRef, { format: 'png', quality: 1 });
                addImageSlide(pres, `Job ${selectedJob}: Photos`, '', 0, 0, headerShot, footerShot, jobInfoShot);
            }
            // }

            // Save the presentation
            console.log('Saving PowerPoint file...');
            await pres.writeFile({ fileName: 'CostForecastReport.pptx' });
            console.log('PowerPoint file saved successfully');
            setWaiting(false);
        } catch (error) {
            console.error("Error generating PowerPoint:", error);
            console.error("Error stack:", error.stack);
            alert(`Error generating PowerPoint: ${error.message}`);
            setWaiting(false);
        }
    };

    const validCell = (a, b) => {
        const withinRange = Math.abs(pNum(a) - pNum(b)) <= 2;
        return withinRange ? 'transparent' : '#ffcccc'; // Light red for invalid, white for valid
    };

    const JobInfo = () => {
        return (
            <View ref={jobInfoRef} style={{ 
                width: 540, 
                backgroundColor: 'white', 
                padding: 15,
                paddingRight: 20,
                flexDirection: 'row', 
                alignItems: 'flex-start',
                justifyContent: 'space-between' 
            }}>
                <View style={{ flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                    <Text style={{ fontSize: 16, fontWeight: '600', color: '#000', marginBottom: 8 }}>
                        {job?.BU_ID || 'Loading...'} as of {versionInfo && versionInfo.Version_Start_DateTime ? moment(versionInfo.Version_Start_DateTime).format('MMM D, YYYY') : ''}
                    </Text>
                    <Text style={{ fontSize: 14, color: '#000' }}>
                        {startDateActual && completionDateForecast 
                            ? `${moment.utc(startDateActual).format('MMM D, YYYY')} - ${moment.utc(completionDateForecast).format('MMM D, YYYY')}`
                            : startDateActual 
                            ? `${moment.utc(startDateActual).format('MMM D, YYYY')} -`
                            : completionDateForecast
                            ? `- ${moment.utc(completionDateForecast).format('MMM D, YYYY')}`
                            : ''}
                    </Text>
                </View>
                <View style={{ flexDirection: 'column', alignItems: 'flex-end', flex: 1 }}>
                    <Text style={{ fontSize: 16, fontWeight: '600', color: '#000', marginBottom: 8, textAlign: 'right' }}>
                        {job?.BU_Description || ''}
                    </Text>
                    <Text style={{ fontSize: 14, color: '#000', textAlign: 'right' }}>
                        {job?.AR_AB_Name || ''}
                    </Text>
                </View>
            </View>
        );
    };

    const SummaryInfo = () => {
        // Map team codes to full descriptive names
        const teamNames = {
            'STX': 'South Texas',
            'PICKETT': 'Pickett',
            'CUSHING': 'Cushing',
            'PASSTHRU': 'Pass Through',
            'GULF COAST': 'Gulf Coast',
            'FACILITIES': 'Facilities',
            'TERMINALS': 'Terminals',
            'BOLT': 'Bolt',
            'NOR': 'Northern',
            'ETX': 'East Texas',
            'WTX': 'South West',
            'CAPSTONE': 'Capstone',
            'MCLEANS': 'McLeans',
            'DELTA': 'Delta',
            'EASTERN': 'Eastern',
            'EPS': 'EPS',
            'PIPELINE': 'Pipeline',
            'SE': 'Southeast',
        };
        
        const teamDisplayName = teamNames[selectedTeam] || selectedTeam || 'Team';
        
        return (
            <View ref={summaryInfoRef} style={{ 
                width: 540, 
                backgroundColor: 'white', 
                padding: 15,
                paddingRight: 20,
                flexDirection: 'row', 
                alignItems: 'center',
                justifyContent: 'center',
                height: 68
            }}>
                <Text style={{ fontSize: 16, fontWeight: '600', color: '#000', textAlign: 'center' }}>
                    {teamDisplayName} as of {versionInfo && versionInfo.Version_Start_DateTime ? moment(versionInfo.Version_Start_DateTime).format('MMM D, YYYY') : ''}
                </Text>
            </View>
        );
    };

    const HourValidation = () => {
        const [actualHours, setActualHours] = useAtom(actualHoursAtom);
        const [actualHoursTest, setActualHoursTest] = useAtom(actualHoursTestAtom);
        const [budgetHours, setBudgetHours] = useAtom(budgetHoursAtom);
        const [budgetHoursTest, setBudgetHoursTest] = useAtom(budgetHoursTestAtom);
        const [updatedBudgetHours, setUpdatedBudgetHours] = useAtom(updatedBudgetHoursAtom);
        const [updatedBudgetHoursTest, setUpdatedBudgetHoursTest] = useAtom(updatedBudgetHoursTestAtom);
        const [eacHours, setEacHours] = useAtom(eacHoursAtom);
        const [eacHoursTest, setEacHoursTest] = useAtom(eacHoursTestAtom);
        return (
            <View style={{ flexDirection: 'row' }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, alignItems: 'center', padding: 10 }}>
                    <View style={{ flexDirection: 'column', alignItems: 'center' }}>
                        <Text style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 10 }}>Hour Validation</Text>
                        <View style={{ flexDirection: 'row', paddingBottom: 5 }}>
                            <Text style={[s.cellt, { width: 150, textAlign: 'right' }]}>Metric</Text>
                            <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Actual Hours</Text>
                            {/* <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Budget Hours</Text> */}
                            <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Current Budget Hours</Text>
                            <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>EAC Hours</Text>
                        </View>
                        <View style={{ flexDirection: 'row', paddingVertical: 5 }}>
                            <Text style={[s.cell, { width: 150, textAlign: 'right' }]}>Productivity Tracker</Text>
                            <Text style={[s.cell, { width: 130, textAlign: 'right', borderWidth: 1, borderColor: 'black', backgroundColor: validCell(actualHours, actualHoursTest) }]}>{pNum(actualHours) || 'N/A'}</Text>
                            {/* <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(budgetHours, budgetHoursTest) }]}>{pNum(budgetHours) || 'N/A'}</Text> */}
                            <Text style={[s.cell, { width: 130, textAlign: 'right', borderWidth: 1, borderColor: 'black', backgroundColor: validCell(updatedBudgetHours, updatedBudgetHoursTest) }]}>{pNum(updatedBudgetHours) || 'N/A'}</Text>
                            <Text style={[s.cell, { width: 130, textAlign: 'right', borderWidth: 1, borderColor: 'black', backgroundColor: validCell(eacHours, eacHoursTest) }]}>{pNum(eacHours) || 'N/A'}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', paddingVertical: 5 }}>
                            <Text style={[s.cell, { width: 150, textAlign: 'right' }]}>Labor Graph</Text>
                            <Text style={[s.cell, { width: 130, textAlign: 'right', borderWidth: 1, borderColor: 'black', backgroundColor: validCell(actualHours, actualHoursTest) }]}>{pNum(actualHoursTest) || 'N/A'}</Text>
                            {/* <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(budgetHours, budgetHoursTest) }]}>{pNum(budgetHoursTest) || 'N/A'}</Text> */}
                            <Text style={[s.cell, { width: 130, textAlign: 'right', borderWidth: 1, borderColor: 'black', backgroundColor: validCell(updatedBudgetHours, updatedBudgetHoursTest) }]}>{pNum(updatedBudgetHoursTest) || 'N/A'}</Text>
                            <Text style={[s.cell, { width: 130, textAlign: 'right', borderWidth: 1, borderColor: 'black', backgroundColor: validCell(eacHours, eacHoursTest) }]}>{pNum(eacHoursTest) || 'N/A'}</Text>
                        </View>
                    </View>
                </View>
            </View>
        )
    }

    return (
        <ScrollView>
            {/* <View style={[s.container, { flex: 1, minWidth: pageWidth - 300 }]}>
                <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                    {tabs.map((tab) => (
                        <TouchableOpacity
                            key={tab}
                            onPress={() => setActiveTab(tab)}
                            style={[s.tabItem, activeTab === tab && s.activeTab]}
                        >
                            <Text style={[s.tabText, activeTab === tab && s.activeText]}>
                                {tab}
                            </Text>
                        </TouchableOpacity>
                    ))}
                </ScrollView>
            </View> */}
            <View style={{ padding: 20 }}>

                {/* <View style={{ flexDirection: 'row', justifyContent: 'flex-start', marginRight: 'auto' }}>
                    <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                        {versionInfo && versionInfo.Version_Start_DateTime &&
                            <View>
                                <View style={{ backgroundColor: isLiveVersion ? '#192440' : 'white', borderRadius: 5, justifyContent: 'center', padding: 10 }}>
                {/* Render the components inside refs for capturing */}
                <View>
                    <View>
                        <View style={{ flexDirection: 'row' }}>
                            {zoomLevel < 100 && (
                                <View style={{
                                    backgroundColor: '#fff3cd',
                                    borderWidth: 1,
                                    borderColor: '#ffc107',
                                    borderRadius: 5,
                                    padding: 12,
                                    marginLeft: 20,
                                    marginBottom: 10,
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}>
                                    <Text style={{ color: '#856404', fontSize: 14, fontWeight: '500' }}>
                                        ⚠️ Zoom affects quality of images on PowerPoint. Current zoom: {zoomLevel}%. Please set zoom to 100% or greater for best results.
                                    </Text>
                                </View>
                            )}
                        </View>
                        <View style={{ flexDirection: 'row' }}>
                            <Pressable
                                onPress={generatePptxReport}
                                disabled={waiting}
                                style={{
                                    backgroundColor: waiting ? '#4a5568' : '#192440',
                                    borderRadius: 5,
                                    justifyContent: 'center',
                                    padding: 10,
                                    marginLeft: 20,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    opacity: waiting ? 0.7 : 1
                                }}>
                                <Text style={{ color: 'white', paddingRight: waiting ? 10 : 0 }}>Create PSR Slides</Text>
                                {waiting && (
                                    <div style={{
                                        width: '16px',
                                        height: '16px',
                                        border: '2px solid rgba(255, 255, 255, 0.3)',
                                        borderTopColor: 'white',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }} />
                                )}
                            </Pressable>
                            <Pressable
                                onPress={generatePptxReportSummary}
                                disabled={waitingSummary}
                                style={{
                                    backgroundColor: waitingSummary ? '#4a5568' : '#192440',
                                    borderRadius: 5,
                                    justifyContent: 'center',
                                    padding: 10,
                                    marginLeft: 20,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    opacity: waitingSummary ? 0.7 : 1
                                }}>
                                <Text style={{ color: 'white', paddingRight: waitingSummary ? 10 : 0 }}>Create PSR Slide - Summary</Text>
                                {waitingSummary && (
                                    <div style={{
                                        width: '16px',
                                        height: '16px',
                                        border: '2px solid rgba(255, 255, 255, 0.3)',
                                        borderTopColor: 'white',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }} />
                                )}
                            </Pressable>
                        </View>
                    </View>
                </View>
                {/* Render the components inside refs for capturing */}
                <View>
                    <View>
                        {/* <Pressable onPress={generatePptxReport} style={{ backgroundColor: '#192440', borderRadius: 5, justifyContent: 'center', padding: 10, marginLeft: 20, width: 180, flexDirection: 'row' }}>
                            <Text style={{ color: 'white', paddingRight: 20 }}>Create PSR Slides</Text>
                            {waiting ? <Text style={{ color: 'white' }}>...</Text> : null}
                        </Pressable>
                        <Text style={{ marginLeft: 20 }}>Zoom affects quality of images on powerpoint. Zoom 100% or greater is best</Text>
                        <Pressable onPress={generatePptxReportSummary} style={{ backgroundColor: '#192440', borderRadius: 5, justifyContent: 'center', padding: 10, marginLeft: 20, width: 180, flexDirection: 'row' }}>
                            <Text style={{ color: 'white', paddingRight: 20 }}>Create PSR Slide - Summary</Text>
                            {waitingSummary ? <Text style={{ color: 'white' }}>...</Text> : null}
                        </Pressable> */}
                        <View style={{ flexDirection: 'row' }}>
                            <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, alignItems: 'center' }}>
                                <View style={{ flexDirection: 'row' }}>
                                    {/* <Text style={[s.cellt, { width: 380 }]}></Text> */}
                                    {/* <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>Gross Margin %</Text>
                                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Backlog</Text>
                                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev. WIP Gain/Fade %</Text> */}
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>Forecast</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>CO Log</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>Productivity</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>Labor Graphs</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>Labor Ratios</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>3rd Party</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5, marginRight: 1 }]}>Revenue Curve</Text>
                                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'center', padding: 5 }]}>Photos</Text>
                                </View>
                                <View>
                                    <View style={{ flexDirection: 'row' }}>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setForecast(!forecast) }}>
                                            <Icon2 name={forecast ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setCoLog(!coLog) }}>
                                            <Icon2 name={coLog ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setProductivity(!productivity) }}>
                                            <Icon2 name={productivity ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setLaborGraphs(!laborGraphs) }}>
                                            <Icon2 name={laborGraphs ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setLaborRatios(!laborRatios) }}>
                                            <Icon2 name={laborRatios ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setThirdParty(!thirdParty) }}>
                                            <Icon2 name={thirdParty ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 91, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setRevenueCurve(!revenueCurve) }}>
                                            <Icon2 name={revenueCurve ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                        <Pressable style={{ width: 90, alignItems: 'center', justifyContent: 'center' }} onPress={a => { setPhotos(!photos) }}>
                                            <Icon2 name={photos ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                        </Pressable>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={{ flexDirection: 'row', marginLeft: 20, marginBottom: 10 }}>
                            <Pressable style={{ flexDirection: 'row', alignItems: 'center' }} onPress={a => { setHideProgram(!hideProgram) }}>
                                <Icon2 name={hideProgram ? "checkbox-marked" : "checkbox-blank-outline"} size={25} color="black" />
                                <Text style={{ marginLeft: 8, fontSize: 14 }}>Hide Program</Text>
                            </Pressable>
                        </View>
                        <JobInfo />
                        <SummaryInfo />
                        <HourValidation />
                        {/* <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, alignItems: 'center', padding: 10 }}>
                            <View style={{ flexDirection: 'column', alignItems: 'center', marginTop: 20 }}>
                                <Text style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 10 }}>Hour Validation</Text>
                                <View style={{ flexDirection: 'row', paddingBottom: 5 }}>
                                    <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Metric</Text>
                                    <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Actual Hours</Text>
                                    <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Budget Hours</Text>
                                    <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>Current Budget Hours</Text>
                                    <Text style={[s.cellt, { width: 130, textAlign: 'right' }]}>EAC Hours</Text>
                                </View>
                                <View style={{ flexDirection: 'row', paddingVertical: 5 }}>
                                    <Text style={[s.cell, { width: 130, textAlign: 'right' }]}>Productivity Tracker</Text>
                                    {actualHoursRef.currenttrue ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(actualHoursRef.current, actualHoursTestRef.current) }]}>{pNum(actualHoursRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                    {budgetHoursRef.current ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(budgetHoursRef.current, budgetHoursTestRef.current) }]}>{pNum(budgetHoursRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                    {updatedBudgetHoursRef.current ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(updatedBudgetHoursRef.current, updatedBudgetHoursTestRef.current) }]}>{pNum(updatedBudgetHoursRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                    {eacHoursRef.current ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(eacHoursRef.current, eacHoursTestRef.current) }]}>{pNum(eacHoursRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                </View>
                                <View style={{ flexDirection: 'row', paddingVertical: 5 }}>
                                    <Text style={[s.cell, { width: 130, textAlign: 'right' }]}>Labor Graph</Text>
                                    {actualHoursTestRef.currenttrue ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(actualHoursRef.current, actualHoursTestRef.current) }]}>{pNum(actualHoursTestRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                    {budgetHoursTestRef.current ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(budgetHoursRef.current, budgetHoursTestRef.current) }]}>{pNum(budgetHoursTestRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                    {updatedBudgetHoursRef.current ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(updatedBudgetHoursRef.current, updatedBudgetHoursTestRef.current) }]}>{pNum(updatedBudgetHoursTestRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                    {eacHoursTestRef.current ? <Text style={[s.cell, { width: 130, textAlign: 'right', backgroundColor: validCell(eacHoursRef.current, eacHoursTestRef.current) }]}>{pNum(eacHoursTestRef.current) || 'N/A'}</Text> : <Text style={[s.cell, { width: 130 }]}></Text>}
                                </View>
                            </View>
                        </View> */}
                    </View>
                </View>
                {/* <Summary view={summaryRef} photo={true}/> */}
                {filteredJobs.map((job, index) => (
                    <View key={index}>
                        <Summary setJobInfoRef={setJobRef} setJobRef={setJobRef} photo={true} hideProgram={hideProgram} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20, marginTop: 30 }}>Slide 1</Text>
                        <Forecast setJobInfoRef={setJobRef} setJobRef={setJobRef} photo={true} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20 }}>Slide 2</Text>
                        <COLogPSRView setJobRef={setJobRef} photo={true} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20 }}>Slide 3</Text>
                        <ProductivityCombined setJobRef={setJobRef} photo={true} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20 }}>Slide 4</Text>
                        <LaborClassification setJobRef={setJobRef} photo={true} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20 }}>Slide 5</Text>
                        <LaborGraphs setJobRef={setJobRef} photo={true} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20 }}>Slide 6</Text>
                        <ThirdPartyCostDrivers setJobRef={setJobRef} photo={true} job={job} />
                        <Text style={{ fontWeight: 600, fontSize: 22, marginLeft: 20 }}>Slide 7</Text>
                        <CostCurveForecast setJobRef={setJobRef} photo={true} job={job} />
                        <Image ref={imageForecastRef} source={forecastTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageCoLogRef} source={coLogTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageLaborGraphsRef} source={laborGraphsTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageLaborRatiosRef} source={laborClassificationTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageProductivityRef} source={productivityTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageThirdPartyRef} source={thirdPartyTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageRevenueCurveRef} source={revenueCurveTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageSummaryRef} source={summaryTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imagePhotoRef} source={photosTop}
                            style={{ width: 1804, height: 172 }} />
                        <Image ref={imageFooterRef} source={footer}
                            style={{ width: 3001, height: 68 }} />


                    </View>
                ))}
            </View>
        </ScrollView>
    );
};

export default PSRSlideJob;


